/**
 * Job column configuration (NO JSX)
 *
 * Defines column metadata including labels, widths, and sortability
 *
 * ⚠️ MIGRATION IN PROGRESS
 * Column widths have been migrated to central registry:
 * Location: src/components/table/columns/registry.ts
 *
 * This file now only contains COLUMN_LABELS for backward compatibility.
 * Width constants (COLUMN_WIDTHS, COLUMN_SORTABLE) are deprecated.
 *
 * Migration: 2025-11-15
 */

/**
 * Column labels for jobs table
 */
export const COLUMN_LABELS: Record<string, string> = {
  status: 'Status',
  type: 'Job Type',
  source: 'Source',
  target: 'Target',
  created: 'Job Creation',
  updated: 'Last Updated',
};

/**
 * @deprecated Use getColumnWidth('job', columnId) from registry instead
 *
 * Column fixed widths (undefined = flex)
 */
export const COLUMN_WIDTHS: Record<string, number | undefined> = {
  status: 100,
  sourceTarget: undefined, // Flexible width
  updated: undefined, // Flexible width
};

/**
 * @deprecated Sortable configuration now in registry
 *
 * Column sortability configuration
 */
export const COLUMN_SORTABLE: Record<string, boolean> = {
  status: false,
  sourceTarget: false,
  updated: false,
};

/**
 * @deprecated Alignment configuration now in column definitions
 *
 * Column alignment configuration
 */
export const COLUMN_ALIGNMENT: Record<string, 'left' | 'center' | 'right'> = {
  status: 'center',
  sourceTarget: 'left',
  updated: 'left',
};

/**
 * Default column order for jobs table
 */
export const DEFAULT_COLUMN_ORDER = [
  'status',
  'type',
  'source',
  'target',
  'created',
  'updated',
];
